import Chart from "react-apexcharts";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { Stack } from "@bookingcom/bui-react";
import { ChartHeader } from "../ChartHeader";
import { ChartYaxisTitle } from "../ChartYaxisTitle";
import { useDiscountedBookingsChartController } from "./DiscountedBookingsChart.controller";
import type { Metric } from "../../../types";
import { CHART_HEIGHT } from "../ChartConstants";
import "../Charts.css";

export type DiscountedBookingsChartProps = { metric: Metric };

export const DiscountedBookingsChart = ({ metric }: DiscountedBookingsChartProps) => {
  const i18n = useI18n();
  const { totalBookings, options, series } = useDiscountedBookingsChartController({ metric });

  return (
    <Stack>
      <ChartHeader
        titleText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_one_name"))}
        titleTooltipText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_one_tooltip"))}
        subtitleText={i18n.trans(
          t("flights_airline_portal_realtime_performance_metric_one_subheader", {
            variables: { num_bookings: totalBookings },
          })
        )}
        subtitleValue={totalBookings.toString()}
      />
      <Stack mixin={{ position: "relative" }}>
        <ChartYaxisTitle titleText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_one_yaxis"))} />
        <Chart options={options} series={series} type="line" height={CHART_HEIGHT} />
      </Stack>
    </Stack>
  );
};
